<template>
  <div>
    <div v-if="!isAutista" class="navetta" v-bind:class="{'route-select-open':routeSelectOpen}">
      <div class="slots" v-if="!alreadyReserved">
        <div
          v-on:tap="changeSelectedDay(SLOTDAY.OGGI)"
          v-bind:class="{selected: selectedSlotDay=== SLOTDAY.OGGI}"
        >
          <span>Oggi</span>
        </div>
        <div
          v-on:tap="changeSelectedDay(SLOTDAY.DOMANI)"
          v-bind:class="{selected: selectedSlotDay===SLOTDAY.DOMANI}"
        >
          <span>{{domaniText}}</span>
        </div>
      </div>
      <div class="slots text-center" v-else>
        <div>
          <span>La tua prenotazione</span>
        </div>
      </div>

      <div class="navetta-overlay-container">
        <div class="navetta-overlay" v-on:tap.self="routeSelectOpen=false" v-if="routeSelectOpen"></div>
        <div class="edit-cards-container">
          <div class="slots-time" v-if="!alreadyReserved">
            <div
              class="grow timeSlot"
              v-on:tap="selectMattina()"
              v-bind:class="{selected: selectedSlot===SLOTS.MATTINA}"
            >Mattina</div>
            <div
              class="grow timeSlot"
              v-on:tap="selectedSlot=SLOTS.POMERIGGIO"
              v-bind:class="{selected: selectedSlot===SLOTS.POMERIGGIO}"
            >Pomeriggio</div>
          </div>
          <div class="edit-card vertical-flex edit-card-start" v-if="!alreadyReserved">
            <div class="edit-card-item">
              <img class="icon-navetta-location" src="../../assets/images/icona_navetta_luogo.svg" />
              <span class="label navetta-label">{{navettaTracking}}</span>
            </div>
            <div
              class="edit-card-item full-width"
              v-if="!alreadyReserved && selectedSlot===SLOTS.MATTINA"
            >
              <div class="select-container">
                <div class="fake-select" v-bind:class="{open:routeSelectOpen}">
                  <div v-on:tap="toggleSelect" class="fake-select-label">
                    <span v-if="selectedRoute==='' || routeSelectOpen">seleziona la sede</span>
                    <span v-else>{{selectedRoute}}</span>
                    <img class="icon-arrow" src="../../assets/images/blue_angle-arrow-down.svg" />
                  </div>
                  <div class="fake-select-option-container">
                    <div
                      class="fake-select-option"
                      v-bind:class="{selected: route===selectedRoute}"
                      v-for="route in currentSelectRoutes"
                      v-bind:key="route"
                      v-on:tap="selectRoute(route)"
                    >{{route}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="edit-card-item full-width"
              v-if="!alreadyReserved && selectedSlot===SLOTS.POMERIGGIO"
            >
              <div class="select-container">
                <div class="fake-select" v-bind:class="{open:routeSelectOpen}">
                  <div v-on:tap="toggleSelect" class="fake-select-label">
                    <span v-if="selectedRoute==='' || routeSelectOpen">seleziona la sede</span>
                    <span v-else>{{selectedRoute}}</span>
                    <img class="icon-arrow" src="../../assets/images/blue_angle-arrow-down.svg" />
                  </div>
                  <div class="fake-select-option-container">
                    <div
                      class="fake-select-option"
                      v-bind:class="{selected: route===selectedRoute}"
                      v-for="route in currentSelectRoutes"
                      v-bind:key="route"
                      v-on:tap="selectRoute(route)"
                    >{{route}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-card-item" v-if="!alreadyReserved && selectedSlot===SLOTS.POMERIGGIO">
              <!-- <img class="icon-navetta-location" src="../../assets/images/icona_navetta_luogo.svg" /> -->
              <span class="label navetta-label navetta-label-pomeriggio">a Stazione Balduina</span>
            </div>
          </div>
        </div>
        <div class="edit-card vertical-flex box-navetta">
          <div class="slots" v-if="!alreadyReserved">
            <div
              v-bind:class="{selected: reservation.timeSlot===timeSlot}"
              v-on:tap="changeTimeSlot(timeSlot)"
              v-for="timeSlot in timeSlots"
              v-bind:key="timeSlot"
            >{{timeSlot}}</div>
          </div>
          <div class="edit-card-item first-icon-container">
            <IconCar />
            <span class="label autista">{{autista}}</span>
          </div>
          <div class="edit-card-item first-icon-container" v-if="alreadyReserved">
            <img src="../../assets/images/map.svg" />
            <span class="label navetta-label">{{alreadyReserved.route}}</span>
          </div>
          <div class="edit-card-item first-icon-container" v-if="alreadyReserved">
            <img src="../../assets/images/calendar.svg" />
            <span class="label">{{formattedSelectedDay}}</span>
          </div>
          <div class="edit-card-item" v-if="!alreadyReserved">
            <img src="../../assets/images/user.svg" />
            <span class="label">{{navettaTiming}}</span>
          </div>
          <div class="edit-card-item" v-if="!!alreadyReserved">
            <img src="../../assets/images/user.svg" />
            <span class="label">{{alreadyReservedTimeSlot}}</span>
          </div>
        </div>
      </div>

      <div
        v-if="!alreadyReserved"
        v-bind:class="{disabled:isSaveDisabled}"
        v-on:tap="saveReservation()"
        class="edit-card edit-card-button"
      >
        <div>Prenota</div>
      </div>
      <div
        v-if="!!alreadyReserved"
        v-on:tap="deleteReservation()"
        class="edit-card edit-card-button"
      >
        <div>Cancella</div>
      </div>
    </div>
    <NavettaAutista v-else></NavettaAutista>
  </div>
</template>
<script>
import IconCar from '../../assets/images/icona_macchina_grey.svg?inline';
import NavettaAutista from '@/components/navetta/NavettaAutista';
import userService from '../../services/User.service';
import config from '../../config';
const now = new Date();
import store from '../../stores';
export default {
  name: 'navetta-reservation-editor',
  components: { IconCar, NavettaAutista },
  props: [
    'selectedDay',
    'reservationType',
    'alreadyReserved',
    'allDayReservations'
  ],
  data() {
    return {
      // isAutista: true,
      SLOTS: SLOT_TYPES,
      SLOTDAY: SLOTDAY_TYPES,
      selectedSlot: this._getSelectedTimeFrameSlot(),
      // selectedSlotDay: SLOTDAY_TYPES.OGGI,
      reservation: {
        timeSlot: this._getSeletedTimeSlot()
      },
      selectedRoute: '',
      routeSelectOpen: false,
      navettaRoutes: {
        departure: {
          mattina: ['staz. Balduina'],
          pomeriggio: ['Piccio', 'Massimi', 'Gregorio VII']
        },
        arrival: {
          mattina: ['Piccio', 'Massimi', 'Gregorio VII'],
          pomeriggio: ['staz. Balduina']
        }
      },
      cache: store.cache
    };
  },
  methods: {
    _getSeletedTimeSlot() {
      const testDate = new Date();
      let timeSlot = this.reservationType.timeSlots.find(t => {
        const splitted = t.split('.');
        testDate.setHours(splitted[0]);
        testDate.setMinutes(splitted[1]);
        return testDate > now;
      });
      if (!timeSlot) {
        this.selectedSlot = SLOT_TYPES.MATTINA;
        this.changeSelectedDay(SLOTDAY_TYPES.DOMANI);
        timeSlot = '08.00';
      }
      return timeSlot;
    },
    _getSelectedTimeFrameSlot() {
      if (this.selectedDay.getDay() !== now.getDay()) {
        return SLOT_TYPES.MATTINA;
      } else {
        if (now.getHours() > 8) {
          return SLOT_TYPES.POMERIGGIO;
        } else {
          return SLOT_TYPES.MATTINA;
        }
      }
    },
    toggleSelect() {
      const y = cumulativeTopOffset(
        document.getElementsByClassName('edit-cards-container')[0]
      );
      document.getElementsByClassName('main')[0].scroll(0, y - 62);
      this.routeSelectOpen = !this.routeSelectOpen;
    },
    selectRoute(route) {
      this.selectedRoute = route;
      this.routeSelectOpen = false;
    },
    saveReservation() {
      if (this.remainingPlaces < 0) {
        return;
      }
      if (this.selectedRoute === '') {
        return;
      }
      let date = new Date(this.selectedDay);
      const splittedTime = this.reservation.timeSlot.split('.');
      date.setHours(splittedTime[0]);
      date.setMinutes(splittedTime[1]);
      const reservation = {
        date: date,
        subtype: this.reservation.subtype,
        route: this.reservationRoute
      };
      const topicDate = new Date(date);
      topicDate.setHours(0);
      topicDate.setMinutes(0);
      topicDate.setSeconds(0);
      topicDate.setMilliseconds(0);
      const timestamp = topicDate.getTime();
      const topic = 'navetta' + timestamp;
      this.subscribeToTopic(topic);
      this.$emit('reserve', reservation);
    },
    deleteReservation() {
      this.$emit('deleteReservation', this.alreadyReserved);
    },
    subscribeToTopic(topic) {
      const user = userService.user;
      if (user.notificationsTopics.indexOf(topic) === -1) {
        user.notificationsTopics.push(topic);
        userService.updateUser(user);
      }
    },
    selectMattina() {
      if (this.isMattinaSelectable) {
        this.selectedSlot = this.SLOTS.MATTINA;
      }
    },
    changeSelectedDay(day) {
      if (day === SLOTDAY_TYPES.OGGI && this.isTodaySelectable) {
        this.$emit('selectedDay', { selectedDay: today });
      } else {
        this.$emit('selectedDay', { selectedDay: tomorrow });
      }
      // this.selectedSlotDay = day;
    },
    changeTimeSlot(timeSlot) {
      let isSelectable = false;
      if (this.selectedDay.getDay() !== now.getDay()) {
        isSelectable = true;
      } else {
        const testDate = new Date();
        const splitted = timeSlot.split('.');
        testDate.setHours(splitted[0]);
        testDate.setMinutes(splitted[1]);
        isSelectable = testDate > now;
      }
      if (isSelectable) {
        this.reservation.timeSlot = timeSlot;
      }
    },
    chooseLoc() {
      console.log(this.$refs);
      this.$refs.arrowLocation.click();
    }
  },
  computed: {
    isAutista() {
      return !!config.autisti.find(a => a.id === userService.user.id);
    },
    isTodaySelectable() {
      return now.getHours() < 19;
    },
    isSaveDisabled() {
      console.log('remainingPlaces', this.remainingPlaces);
      return this.remainingPlaces < 1 || this.selectedRoute === '';
    },
    autista() {
      const date = this.selectedDay;
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      const shifts = this.cache.driverShifts
        .sort((a, b) => b.id - a.id)
        .find(d => d.date === date.getTime());
      if (!!shifts) {
        console.log(shifts);

        if (this.selectedSlot === this.SLOTS.POMERIGGIO) {
          return shifts.shifts.pomeriggio.name;
        } else {
          return shifts.shifts.mattina.name;
        }
      } else {
        return 'Unknown';
      }
    },
    selectedSlotDay() {
      if (this.selectedDay.getDay() === now.getDay()) {
        return SLOTDAY_TYPES.OGGI;
      } else {
        return SLOTDAY_TYPES.DOMANI;
      }
    },
    domaniText() {
      if (now.getDay === 5) {
        return 'Lunedì';
      } else {
        return 'Domani';
      }
    },
    isMattinaSelectable() {
      let isSelectable = false;
      if (this.selectedDay.getDay() === now.getDay()) {
        isSelectable = now.getHours() < 9;
      } else {
        isSelectable = true;
      }
      return isSelectable;
    },
    reservationRoute() {
      let route = '';
      if (this.selectedSlot === this.SLOTS.MATTINA) {
        route = `Da stazione Balduina a ${this.selectedRoute}`;
      } else {
        route = `Da ${this.selectedRoute} a stazione Balduina`;
      }
      return route;
    },
    currentSelectRoutes() {
      return this.navettaRoutes.arrival.mattina;
    },
    slotReservations() {
      return this.allDayReservations.filter(dayReservation => {
        const date = new Date(dayReservation.date);
        const timeSlot = date
          .toLocaleString('it-it', {
            hour: '2-digit',
            minute: '2-digit'
          })
          .split(':')
          .join('.');
        console.log(this.reservation.timeSlot);

        return timeSlot === this.reservation.timeSlot;
      });
    },
    alreadyReservedTimeSlot() {
      const resDate = new Date(this.alreadyReserved.date);
      const timeSlot = resDate
        .toLocaleString('it-it', {
          hour: '2-digit',
          minute: '2-digit'
        })
        .split(':')
        .join('.');
      return `Navetta delle ${timeSlot}`;
    },
    remainingPlaces() {
      return this.reservationType.threshold - this.slotReservations.length;
    },
    navettaTiming() {
      return 'Navetta delle ' + this.reservation.timeSlot;
    },
    navettaTracking() {
      let strTracking;
      if (this.selectedSlot === SLOT_TYPES.MATTINA) {
        strTracking = 'Prenota navetta da staz. Balduina a';
      } else {
        strTracking = 'Prenota navetta da';
      }
      return strTracking;
    },
    formattedSelectedDay() {
      const monthAndYear = this.selectedDay.toLocaleString('it-it', {
        month: 'long',
        year: 'numeric'
      });
      const day = this.selectedDay.getDate();
      return day + ' ' + monthAndYear[0].toUpperCase() + monthAndYear.slice(1);
    },
    timeSlots() {
      let filterFn = s => s.split('.')[0] >= SLOTS_BORDER;
      if (this.selectedSlot === SLOT_TYPES.MATTINA) {
        filterFn = s => s.split('.')[0] < SLOTS_BORDER;
      }
      return this.reservationType.timeSlots.filter(filterFn);
    }
  }
};
const today = new Date();
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);
const SLOT_TYPES = {
  MATTINA: 1,
  POMERIGGIO: 2
};
const SLOTDAY_TYPES = {
  OGGI: 'Today',
  DOMANI: 'Tomorrow'
};
const SLOTS_BORDER = 13;
function cumulativeTopOffset(element) {
  let top = 0;
  do {
    top += element.offsetTop || 0;
    element = element.offsetParent;
  } while (element);

  return top;
}
</script>
<style lang="scss" scoped>
.navetta {
  .edit-card {
    align-content: center;
    // padding: 0 0;
    // margin-top: 18px;
    img {
      width: 18px;
    }

    img,
    svg,
    i {
      margin: 0 20px 0 0;
      position: relative;

      &.rds-icon-car {
        color: $main-blue;
      }
    }

    .label {
      flex-grow: 1;
    }

    & > div {
      display: flex;

      &.edit-card-item {
        width: 90%;
        padding: 26px 0;
        align-items: center;
        display: flex;
        &.full-width {
          width: 100%;
          padding-bottom: 0;
        }
        &:nth-child(1) {
          border-radius: $default-border-radius;
        }
        &:nth-last-child(1) {
          border-radius: $default-border-radius;
        }
        .label {
          color: #000000;
        }
        img,
        i {
          position: relative;
          opacity: 0.5;
        }
      }
    }

    &.box-navetta {
      padding: 0;
    }
  }

  .time-slots {
    width: 100%;
    padding-bottom: 10px !important;
    background-color: #f7f7f7;

    .timeSlot {
      background-color: #e5e5e5;
      width: 100%;
      border: #f6f6f6 solid 1px;
      color: #7a7f85;
      height: 52px;
      align-items: center;
      justify-content: center;
      display: flex;
      text-align: center;
      margin-left: 8px;
      &:nth-child(1) {
        margin-left: 0;
      }
      &.selected {
        background-color: $main-blue;
        color: #ffffff;
      }
      &.finished {
        background-color: #a31313;
        color: #ffffff;
      }
    }
  }

  .vertical-flex {
    // img {
    //   margin: 0 24px 30px;
    // }
    padding: 20px 0 30px;
    /*.first-icon-container {
        position: relative;
        &:after {
          position: absolute;
          content: '';
          background-image: url(/img/linea_tratteggiata_vericale.84d35209.svg);
          background-position: bottom;
          background-repeat: repeat-y;
          content: '';
          position: absolute;
          top: 0;
          left: 24px;
          height: 100px;
          width: 10px;
        }
      }*/
    .edit-card-item {
      background-color: #ffffff;
      position: relative;
      &::after {
        // background-image: linear-gradient(to right, #707070 50%, rgba(255, 255, 255, 0) 0%);
        // background-image: linear-gradient(90deg, #707070, #707070 75%, transparent 75%, transparent 100%);
        background-image: url('../../assets/images/linea_tratteggiata_orizzontale.svg');
        background-position: bottom;
        background-repeat: repeat-x;
        content: '';
        position: absolute;
        width: 90%;
        bottom: 0;
        //left: 2%;
        text-align: center;
        height: 10px;
      }
      &:nth-last-child(1) {
        &::after {
          content: none;
        }
      }
      .icon-navetta-location {
        opacity: 1;
        height: 21px;
      }
    }
  }
  .navetta-choose-loc {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 2;
  }
  .select-container {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .edit-card-item .fake-select {
    width: 100%;
    .icon-arrow {
      opacity: 1;
      width: 8px;
      margin: 0;
      transition: all 0.3s;
    }
    .fake-select-label {
      padding: 0 22px 26px;
      display: flex;
      span {
        flex-grow: 1;
      }
    }
    .fake-select-option-container {
      // background-color: #e5e5e5;
      background-color: rgba(0, 0, 0, 0.05);
      padding: 0 22px 0;
      max-height: 0;
      overflow: hidden;
      transition: all 0.3s;
    }
    &.open {
      .icon-arrow {
        transform: rotate(90deg);
      }
      .fake-select-option-container {
        max-height: 210px;
      }
    }

    .fake-select-option {
      padding: 26px 0;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-bottom: rgba(61, 61, 61, 0.3) solid 0.6px;
      }
      &:nth-last-child(1):after {
        content: none;
      }
    }
    .fake-select-label,
    .fake-select-option.selected {
      color: #1c3498;
    }
  }

  .autista {
    letter-spacing: 1px;
  }

  .box-autista {
    background-color: #ffffff;
  }
  .navetta-label {
    font-size: 0.9em;
    &.navetta-label-pomeriggio {
      margin-left: 9px;
    }
  }

  /*DONATO*/
  .edit-card {
    padding: 0 0;
    margin-top: 18px;
    .slots {
      width: 100%;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      color: #000000;
    }
  }
  .navetta-overlay-container {
    position: relative;
    .navetta-overlay {
      position: absolute;
      width: 100vw;
      height: 100%;
      left: -21px;
      top: 0;
      background-color: rgba(0, 0, 0, 0.72);
      z-index: 1;
    }
    .edit-cards-container {
      z-index: 2;
      position: relative;
    }
  }
  .slots.text-center {
    text-align: center;
    & > * {
      width: 100%;
      color: rgba(0, 0, 0, 1);
    }
  }
  .slots-time {
    width: 100%;
    // padding-top: 20px;
    // padding-bottom: 20px;
    margin: 0 0 20px;
    padding-top: 20px;
    // background-color: #f7f7f7;
    display: flex;
    .timeSlot {
      background-color: #e5e5e5;
      width: 100%;
      // border: #f6f6f6 solid 1px;
      color: #000000;
      padding: 13px 0;
      text-align: center;
      margin-left: 8px;
      border-radius: 5px;
      &:nth-child(1) {
        margin-left: 0;
      }
      &.selected {
        background-color: $main-blue;
        color: #ffffff;
      }
      &.finished {
        background-color: #a31313;
        color: #ffffff;
      }
    }
  }
  .edit-card-button.disabled {
    background-color: rgba(193, 40, 40, 0.6);
  }
}
</style>
